module.exports = __webpack_public_path__ + "img/poly-9.745c1a79.png";